export default __webpack_public_path__ + "static/media/flat-color-icons_google.c3c756b0.svg";